<template>
<el-drawer
  :title="editRow && editRow.id ? '修改成员' : '新增成员'"
  :visible.sync="show">
  <div class="drawer-box" v-loading="loading">
    <el-form label-position="top" :model="model" :rules="rules" ref="modelForm">
      <!-- <div class="form-title">基本信息</div>  -->
      <!-- 账号 -->
      <el-form-item label="账号" prop="mobilePhone" :rules="[{
        required: true,
        message: '请输入账号',
        trigger: 'blur' }]">
        <el-input maxlength="30"
          :disabled="!!editRow"
          show-word-limit placeholder="建议输入手机号" v-model="model.mobilePhone" />
      </el-form-item>


      <el-form-item label="昵称" prop="nickName" :rules="[{
        required: true,
        message: '请输入昵称',
        trigger: 'blur' }]">
        <el-input placeholder="请输入昵称" v-model="model.nickName" />
      </el-form-item>

      <el-form-item label="密码" prop="zsPwd" :rules="[{
        required: true,
        message: '请输入密码',
        trigger: 'blur' }]">
        <el-input type="password" placeholder="请输入密码" v-model="model.zsPwd" />
      </el-form-item>  
      <el-form-item label="角色" prop="roleName" :rules="[{
        required: true,
        message: '请选择',
        trigger: 'blur' }]">
         <el-select v-model="model.roleName" style="width: 100%;" clearable>
            <el-option v-for="(item, index) in roles" :key="index" :label="item.label" :value="item.value"></el-option>
         </el-select>
      </el-form-item>
     
      <el-form-item prop="channelDeduction" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <template slot="label">
          <span>渠道固定扣点（%）
            <el-tooltip class="item" effect="dark" placement="top">
              <template slot="content">
                设置后，该账号在选品库看到的佣金比例会<br />自动比渠道少几个点，并且报单后会按此结算
              </template>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </template>
        <el-input placeholder="请输入数字，固定扣3%填写3" v-model="model.channelDeduction" />
      </el-form-item>
    </el-form>
  </div>
  <el-dialog :visible.sync="showDialog" title="提示" append-to-body width="600px">
    <div class="content-dialog">
      <div>监测到您修改了固定扣点，已报单的订单无法修改，后续新报单的订单将按修改后的固定扣点计算结算佣金，如果需要修改历史订单数据，请联系群内工作人员删除后再让您的下游重新报单。</div>
      <div style="padding-top: 8px; font-weight: bold;">是否确定修改？</div>
    </div>

    <div slot="footer">
      <el-button size="mini" @click="showDialog = false">取消</el-button>
      <el-button size="mini" @click="editHandler(editData)" type="primary">确定</el-button>
    </div>
  </el-dialog>
  <div class="drawer-footer">
    <el-button @click="$emit('close')">取消</el-button>
    <el-button @click="submitHandler" :disabled="submiting" type="primary">确认</el-button>
  </div>
</el-drawer>
</template>

<script> 
import NP from 'number-precision'
import { saveAccount, editAccount} from '@/service/apis/streamAccount' 
export default { 
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editRow: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value: {
      handler: function(val) {
        if (val && this.editRow) {
          this.initForm()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      // 代理，同行，山 
      roles: [{
        name: '代理',
        value: '代理'
      }, {
        name: '同行',
        value: '同行'
      }, {
        name: '散客',
        value: '散客'
      }],
      loading: false,
      rules: {},
      model: {
        mobile: '', 
        nickName: '',
        zsPwd: '',
        roleName: '',
        channelDeduction: ''
      },
      submiting: false,
      editData : null,
      showDialog: false
    }
  },
  created () { 
  },
  methods: {
    // 提交
    submitHandler () {
      this.$refs['modelForm'].validate((valid) => {
        if (valid) {
          let opt = JSON.parse(JSON.stringify(this.model))
          opt.userPromotion = {
            channelDeduction: NP.times(opt.channelDeduction, 1000)
          }
          delete opt.channelDeduction
          
          if (this.editRow && this.editRow.id) {
            let originChannelDeduction = '' // (this.editRow.userPromotion.channelDeduction / 1000).toFixed(2) || ''
            if (this.editRow.userPromotion && this.editRow.userPromotion.channelDeduction) {
              originChannelDeduction = this.editRow.userPromotion.channelDeduction
            }
            
            if (opt.userPromotion.channelDeduction !== originChannelDeduction) {
              this.editData = {
                id: this.editRow.id,
                ...opt
              }
              this.showDialog = true
              return false
            }
            this.editHandler({
              id: this.editRow.id,
              ...opt
            })
          } else {
            this.addHandler(opt)
          }
        } else {
          return false;
        }
      })
    },
    initForm () {
      if (this.editRow && this.editRow.id) {
        this.model.mobilePhone = this.editRow.mobilePhone
        this.model.nickName = this.editRow.nickName
        this.model.roleName = this.editRow.roleName
        if (this.editRow.zsPwd) {
          this.model.zsPwd = this.editRow.zsPwd
        }
        if (this.editRow.userPromotion && this.editRow.userPromotion.channelDeduction) {
          this.model.channelDeduction = (this.editRow.userPromotion.channelDeduction / 1000).toFixed(2)
        }
      }
    },
    // 新增
    addHandler (opt) {
      this.submiting = true
      saveAccount.call(this, {...opt, status: 1}).then(res => {
        this.$message.success('新增成功')
        this.$emit('on-success')
      }).finnaly(() => {
        this.submiting = false
      })
    },
    // 修改
    editHandler (opt) {
      this.showDialog = false
      this.submiting = true
      editAccount.call(this, opt).then(res => {
        this.$message.success('修改成功')
        this.$emit('on-success')
      }).finnaly(() => {
        this.submiting = false
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-form-item__error {
  padding-top: 3px;
}
.form-title {
  font-size: 16px;
  margin-bottom: 12px;
  border-left: 2px solid #9dc2cf;
  padding-left: 8px;
  font-weight: normal;
}
.content-dialog {
  line-height: 24px;
}
</style>
